import humanize from "../../interceptors/error-messages";
import jquery from 'jquery';
import jsbarcode from 'jsbarcode';
import qrcode from 'qrcode';
import slickCarousel from 'slick-carousel';
import fingerprintjs2 from 'fingerprintjs2';
import Vue from 'vue';
import axios from 'axios';
import 'js-marker-clusterer';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = jquery;

window.BarCode = jsbarcode;

window.QRCode = qrcode;

// Slick
window.$.slick = slickCarousel;

window.Fingerprint2 = fingerprintjs2;

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = Vue;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * interceptor para os responses;
 */
humanize(window.axios);

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
